<span *ngFor="let item of items; let index = index; let count = count">
  <a [routerLink]="item.link">
    {{item.name}}
  </a>
  <span *ngIf="count > 1 && count > index + 2">,</span>
  <span *ngIf="count > 1 && count === index + 2">and</span>
</span>
